
import * as React from 'react';

import LoginIcon from '@mui/icons-material/Login';
import { Button } from '@mui/material';
import classNames from 'classnames';
import { AccountContext } from '../context/account';
import useLoggedIn from '../hooks/useLoggedIn';
import styles from '../styles/components/login-panel.module.scss';
import { StyledMarkdown } from './typeface';

interface LoginPanelProps {
  top?: number;
  children?: React.ReactNode;
  absolute?: boolean;
  message?: string;
  className?: string;
  inline?: boolean;
}

export const LoginPanel = ({
  top = 0,
  children = <></>,
  absolute = true,
  message = 'Please **login** or **create a free account** for full access.',
  className = '',
  inline = false,
}: LoginPanelProps) => {

  const { setShowLoginModal } = React.useContext(AccountContext);
  const showLoginPanel = !useLoggedIn();
  
  if (!showLoginPanel) {
    return null;
  }
  if (inline) {
    return <>
      <Button
        id="login-to-add-to-basket-button"
        type='button'
        size='small'
        // color="success"
        variant="contained"
        startIcon={<LoginIcon style={{color: '#fff'}} />}
        onClick={(e: React.SyntheticEvent) => {
          e.preventDefault()
          setShowLoginModal(true)
        }}
      >
        Login to add to basket
      </Button>
    </>
  }

  return (
    <div 
      style={{top: `${top}px`}}
      className={classNames(className, styles.loginPanel, {
        [styles.absolute]: absolute
      })}>
      <StyledMarkdown>
        {message}
      </StyledMarkdown>
      <Button
        type='button'
        size='small'
        // color="success"
        variant="contained"
        startIcon={<LoginIcon style={{color: '#fff'}} />}
        onClick={(e: React.SyntheticEvent) => {
          e.preventDefault()
          setShowLoginModal(true)
        }}
      >
        Login
      </Button>
    </div>
  )

}